import styled from 'styled-components'

import { IconThreeDots } from 'assets/svg/sprite'
import colors from 'styles/colors'

interface IProps {
    onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
    color?: string
    className?: string
}

export const ThreeDotsTrigger = ({
    onClick,
    color = colors.white,
    className
}: IProps) => {
    return (
        <Wrapper
            className={`post-options-trigger ${className}`}
            onClick={onClick}
        >
            <IconThreeDots color={color} />
        </Wrapper>
    )
}

const Wrapper = styled.div`
    position: absolute;
    padding: 1rem;
    top: 1.8rem;
    right: 4rem;
    z-index: 7;
        .discoverModal & {
        @media (min-width: 950px) {
            right: 2rem;
        }
    }
`
